import { ChartGroupTotals } from '@common/types';

export interface DemographicsProps {
  selectedPillId: string;
  data: DemographicsData;
}

export interface DemographicsBy {
  collectionLocation: string;
  status: string;
  type: string;
  groupValue: string;
  value: number;
}
export interface DemographicsData {
  byRaceEthnicity: DemographicsBy[];
  byPreferredLanguage: DemographicsBy[];
  byAgeRange: DemographicsBy[];
  byBiologicalSex: DemographicsBy[];
}

export enum DemographicsByPropName {
  COLLECTION_LOCATION = 'collectionLocation',
  STATUS = 'status',
  TYPE = 'type',
  GROUP_VALUE = 'groupValue',
  VALUE = 'value',
  CLINIC = 'clinic',
}

export enum DemographicsOptionType {
  COLLECTION_LOCATION = 'COLLECTION_LOCATION',
  STATUS = 'STATUS',
  SAMPLE_TYPE = 'SAMPLE_TYPE',
  CLINIC = 'CLINIC',
}

export enum CollectionLocationSelectId {
  ALL = 'ALL_COLLECTION_LOCATIONS',
  IN_PERSON = 'IN_PERSON',
  AT_HOME = 'AT_HOME',
}

export enum SampleStatusSelectId {
  ALL = 'ALL_STATUS_TYPES',
  AWAITING = 'AWAITING',
  IN_SEQUENCING = 'IN_SEQUENCING',
  RECEIVED = 'RECEIVED',
  RECOLLECT = 'RECOLLECT',
  SEQUENCING_COMPLETE = 'SEQUENCING_COMPLETE',
  RESULTS_DELIVERED = 'RESULTS_DELIVERED',
  VALID = 'VALID',
}

export enum SampleTypeSelectId {
  ALL = 'ALL_SAMPLE_TYPES',
  BLOOD_SAMPLES = 'BLOOD',
  SALIVA_SAMPLES = 'SALIVA',
  BUCCAL_SAMPLES = 'BUCCAL_SWAB',
}

export enum TogglePillOptionId {
  LIST_VIEW = 'list_view',
  MAP_VIEW = 'map_view',
}

export interface DataItem {
  groupValue: string;
  value: number;
}

export interface GroupedDemographicsData {
  byRaceEthnicity: ChartGroupTotals[];
  byPreferredLanguage: ChartGroupTotals[];
  byAgeRange: ChartGroupTotals[];
  byBiologicalSex: ChartGroupTotals[];
}
